<template>
<transition name="modal">
  <!--
    閉じるのは背景を押したときだけ。中のどこを押しても閉じていたので、
    ［登録］を押した瞬間に小窓が消え、断られても元の画面に戻っただけに見えた。
    背景は wrapper が覆っているので、両方で受ける。
  -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal-wrapper" @click.self="$emit('close')">
      <div class="modal-container">
        <div>
          <CRow>
            <CCol>
              <table class="table">
                <thead>
                  <a style="font-size: 20px"><strong>登録内容確認</strong></a>
                  <CCardText><strong>以下の内容を登録してよろしいですか？</strong></CCardText>
                </thead>
                <tbody>
                  <tr><td><strong>部署名</strong><br>{{ name }}</td></tr>
                  <tr><td><strong>部署コード</strong><br>{{ code }}</td></tr>
                  <tr><td><strong>親部署</strong><br>{{ parent_name }}</td></tr>
                  <tr><td><strong>部署長</strong><br>{{ head_user_name }}</td></tr>
                  <tr><td><strong>並び優先度</strong><br>{{ order_level }}</td></tr>
                  <tr><td><strong>備考</strong><br>{{ remarks }}</td></tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <ActionResultMessage :text="error" type="danger" />
          <CRow>
            <CCol>
              <button @click="$emit('close')" :disabled="loading" class="btn btn-secondary btn-sm">キャンセル</button>
            </CCol>
            <CCol>
              <save-button
                :label="'登録'"
                :loading="loading"
                @click="$emit('register')"
                class="btn btn-info"
              />
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
import ActionResultMessage from '../components/ActionResultMessage.vue'
export default {
  name: 'DepartmentRegisterModal',
  components: { SaveButton, ActionResultMessage },
  props: {
    name: String,
    code: String,
    parent_name: String,
    head_user_name: String,
    order_level: [String, Number],
    remarks: String,
    loading: Boolean,
    // 登録を断られた理由。小窓を閉じずにここへ出す。
    error: { type: String, default: '' }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper { display: table-cell; vertical-align: middle; }
.modal-container {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
}
</style>
